module.exports = __webpack_public_path__ + "img/check-square-alternate.92e97dba.svg";